import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star } from "lucide-react";
import { REVIEWS } from "@/data";

const ease = [0.16, 1, 0.3, 1];

export const ReviewFlash = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % REVIEWS.length);
    }, 5000);
    return () => clearInterval(id);
  }, []);

  const review = REVIEWS[index];

  return (
    <div
      className="pointer-events-none absolute inset-x-0 bottom-0 p-4 sm:p-6"
      data-testid="review-flash"
    >
      {/* Verified badge */}
      <a
        href="https://www.purplegarden.co/psychics/10530-yasha"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="review-badge-link"
        className="pointer-events-auto mb-3 inline-flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-[#E9D3A0] transition-colors hover:text-[#F4E6C4]"
      >
        <span className="flex items-center gap-0.5">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="w-3 h-3 fill-[#C9A24B] text-[#C9A24B]" strokeWidth={0} />
          ))}
        </span>
        <span data-testid="review-badge" className="underline decoration-[#C9A24B]/40 underline-offset-4">
          5-Star Psychic · Purple Garden
        </span>
      </a>

      {/* Rotating review */}
      <div className="relative min-h-[76px] rounded-md border border-[#C9A24B]/25 bg-[#140B09]/70 px-5 py-4 backdrop-blur-md">
        <AnimatePresence mode="wait">
          <motion.blockquote
            key={index}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.9, ease }}
            className="text-[#EFE3CC]"
            data-testid="review-quote"
          >
            <p className="font-display italic leading-relaxed text-[15px] sm:text-base">
              {review.text}
            </p>
            <footer className="mt-2 text-[11px] tracking-[0.24em] uppercase text-[#C9A24B]">
              — {review.author}
            </footer>
          </motion.blockquote>
        </AnimatePresence>
      </div>
    </div>
  );
};
